import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next/pages';
import { ReactElement, useState } from 'react';
import { HeaderLinkAccordion } from './HeaderLinkAccordion';
import { headerLinks } from './headerLinks';
interface HeaderMenuPanelProps {
  onClose: () => void;
}
export function HeaderMenuPanel(t0) {
  const $ = _c(25);
  const {
    onClose
  } = t0;
  const {
    t
  } = useTranslation("apps-resources");
  const [expanded, setExpanded] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = panel => (_event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleAccordionChange = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      backgroundColor: "background.default",
      borderRadius: 0,
      position: "relative"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      height: {
        xs: 100,
        lg: 159
      },
      width: "100%"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      xs: 100,
      lg: 159
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      lg: "69px"
    };
    t6 = {
      lg: 14
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      xs: "100%",
      lg: 530
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      height: t4,
      pr: 20,
      py: 10,
      pt: t5,
      pb: t6,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      position: "fixed",
      width: t7,
      zIndex: _temp,
      backgroundColor: "background.default",
      "&::after": {
        content: "\"\"",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: "100%",
        width: "100vw",
        backgroundColor: "background.default"
      }
    };
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      height: 34,
      px: 3.5,
      borderRadius: 4,
      "&:hover": {
        backgroundColor: "background.paper",
        color: "primary.main",
        border: "1px solid",
        borderColor: "primary.main",
        boxShadow: "none"
      }
    };
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      fontSize: 15,
      fontWeight: "bold",
      lineHeight: 1
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t) {
    t11 = t("Give Now", {
      lng: "en"
    });
    $[10] = t;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t11) {
    t12 = <Box sx={t3}><Box sx={t8}><Button href="https://www.jesusfilm.org/how-to-help/ways-to-donate/give-now-2/?amount=&frequency=single&campaign-code=NXWJPO&designation-number=2592320&thankYouRedirect=https%3A%2F%2Fwww.jesusfilm.org%2Fcontent%2Fjf%2Fus%2Fdevelopment%2Fspecial%2Fthank-you-refer%2Fsocial-share.html" rel="noopener" variant="contained" sx={t9}><Typography variant="h6" sx={t10}>{t11}</Typography></Button></Box></Box>;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      justifyContent: "space-between",
      flexGrow: 1,
      py: {
        xs: 17,
        md: 2,
        xl: 0
      }
    };
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      justifyContent: "flex-start",
      gap: {
        xs: "8px"
      }
    };
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== expanded || $[17] !== onClose || $[18] !== t) {
    t15 = headerLinks.map(link => <HeaderLinkAccordion key={link.label} label={t(link.label, {
      lng: "en"
    })} url={link.url} expanded={expanded === link.label} onAccordionChange={handleAccordionChange} subLinks={link.subLinks?.map(subLink => ({
      ...subLink,
      label: t(subLink.label, {
        lng: "en"
      })
    }))} onClose={onClose} />);
    $[16] = expanded;
    $[17] = onClose;
    $[18] = t;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t15) {
    t16 = <Stack direction="column" sx={t13}><Stack direction="column" sx={t14}>{t15}</Stack></Stack>;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t12 || $[23] !== t16) {
    t17 = <Paper elevation={0} data-testid="HeaderMenuPanel" sx={t2}>{t12}{t16}</Paper>;
    $[22] = t12;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  return t17;
}
function _temp(theme) {
  return theme.zIndex.drawer + 1;
}